import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import { useCreateDossierId, useGetDossier } from 'src/networking/terminals'
import { atomDossier, atomPolicy, atomSelectedProduct, selectorDossierInsured } from 'src/storage'
import { mapDossier } from 'src/utils'

export const usePaymentSuccess = () => {
  const { t } = useTranslation()

  const resetDossier = useResetRecoilState(atomDossier)
  const resetPolicy = useResetRecoilState(atomPolicy)
  const resetSelectedProduct = useResetRecoilState(atomSelectedProduct)
  const insured = useRecoilValue(selectorDossierInsured)
  const saveDossier = useSetRecoilState(atomDossier)

  const { crossGate: getDossier } = useGetDossier()
  const { crossGate: createDossierId } = useCreateDossierId()

  useEffect(() => {
    resetPolicy()
    resetSelectedProduct()
    if (!insured || !insured.idAssicurato || !insured.codiceAssociato || !insured.utenteOggettoId) {
      return
    }

    createDossierId(
      {
        body: {
          codiceAssociato: insured?.codiceAssociato,
          associatoId: insured?.idAssicurato,
          utenteOggettoId: insured.utenteOggettoId,
          productCode: null,
        },
      },
      {
        onSuccess: (newDossier) => {
          resetDossier()
          getDossier(
            {
              headers: {
                xDossierId: newDossier.xdossierId,
              },
            },
            {
              onSuccess: (newDossierCreated) => {
                const dossier = mapDossier(newDossierCreated)
                saveDossier(dossier)
              },
            }
          )
        },
      }
    )
  }, [])

  return {
    t,
  }
}
